import { TOURNAMENT_ROLES } from '@/constants';

const KEY_PREFIX = 'tournamentRole:';
const TTL_MS = 7 * 24 * 60 * 60 * 1000;

interface CachedRole {
  userRole: string;
  ts: number;
}

function readCachedUserId(): number | null {
  try {
    const raw = localStorage.getItem('currentUser');
    if (!raw || raw === 'undefined') return null;
    const user = JSON.parse(raw);
    return typeof user?.id === 'number' ? user.id : null;
  } catch {
    return null;
  }
}

function buildKey(userId: number, tournamentId: string | number): string {
  return `${KEY_PREFIX}${userId}:${tournamentId}`;
}

export function getCachedTournamentRole(tournamentId: string | number): string | null {
  try {
    const userId = readCachedUserId();
    if (!userId) return null;
    const raw = localStorage.getItem(buildKey(userId, tournamentId));
    if (!raw) return null;
    const cached = JSON.parse(raw) as CachedRole;
    if (!cached.ts || Date.now() - cached.ts > TTL_MS) return null;
    return cached.userRole;
  } catch {
    return null;
  }
}

export function setCachedTournamentRole(tournamentId: string | number, userRole: string): void {
  try {
    const userId = readCachedUserId();
    if (!userId) return;
    const data: CachedRole = { userRole, ts: Date.now() };
    localStorage.setItem(buildKey(userId, tournamentId), JSON.stringify(data));
  } catch {
    // ignore quota/serialization errors — cache is an optimisation, not load-bearing
  }
}

export function clearAllTournamentRoles(): void {
  try {
    const keys = Object.keys(localStorage).filter(k => k.startsWith(KEY_PREFIX));
    keys.forEach(k => localStorage.removeItem(k));
  } catch {
    // ignore
  }
}

export function isPrivilegedTournamentRole(role: string | null | undefined): boolean {
  return role === TOURNAMENT_ROLES.HOLDER || role === TOURNAMENT_ROLES.MAINTAINER;
}
